import React from "react";
import { History } from "lucide-react";
import { AppButton, AppModal, StatusBadge } from "../ui";

const dateOf = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Kolkata" }) : "");

/**
 * VersionsDialog — every saved version of the course's syllabus, newest first.
 * Loading one puts it in the editor as unsaved changes; saving makes it the
 * newest version. Nothing older is ever changed.
 *
 * Props: show, onHide, versions, onLoad(template)
 */
const VersionsDialog = ({ show, onHide, versions = [], onLoad }) => (
  <AppModal show={show} onHide={onHide} size="md" title="Syllabus versions" icon={<History size={18} aria-hidden="true" />}>
    <p className="tw-m-0 tw-mb-3 tw-text-[0.8125rem] tw-text-content-muted">
      Every save is a new version. Load one to edit from it — it becomes the newest version when you save.
    </p>
    <ol className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-2 tw-p-0">
      {versions.map((v) => {
        const isModule = v.syllabusType === "module";
        const count = isModule ? (v.modules || []).length : (v.days || []).length;
        return (
          <li key={v._id || v.version} className="tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-border tw-border-solid tw-border-line tw-px-3 tw-py-2.5">
            <span className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">
              <span className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-content">
                Version {v.version}
                {v.isActive && <StatusBadge status="active">In use</StatusBadge>}
              </span>
              <span className="tw-text-xs tw-text-content-muted">
                {dateOf(v.createdAt)} · {count} {isModule ? `module${count === 1 ? "" : "s"}` : `day${count === 1 ? "" : "s"}`}
              </span>
            </span>
            <AppButton size="xs" variant="outline" onClick={() => onLoad(v)}>Load</AppButton>
          </li>
        );
      })}
    </ol>
  </AppModal>
);

export default VersionsDialog;
